export const ProfileTranslationsEn = {
  'Nickname must be unique': 'Nickname must be unique',
  save: 'Save',
  lastName: 'Last Name',
  firstName: 'First Name',
  patronymicOptional: 'Patronymic (optional)',
  nickname: 'Nickname',
  phoneNumber: 'Phone Number',
  email: 'Email',
  verifyEmail: 'Verify Email',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  showPassword: 'Show Password',
  enterNewPasswordAgain: 'Enter new password again',
  saveChanges: 'Save Changes',
  profilePhoto: 'Profile Photo',
  maxFileSize: 'Maximum file size - 5 MB',
  verify: 'Verify',
  verified: 'Verified',

  changeEmailMessage:
  'A confirmation email for the change of email has been sent to {{email}}. Please check your mailbox and follow the instructions to confirm.',

  // errors validate
  fieldIsRequired: 'Field is required',
  nameLength: 'Name must be less than 64 characters',
  surnameLength: 'Surname must be less than 64 characters',
  patronymicLength: 'Patronymic must be less than 64 characters',
  latinCharacters:
    'Only Latin letters, digits, hyphens, and underscores are allowed',
  validEmail: 'Please enter a valid email address',
  passwordMinLength: 'Password must be at least 8 characters long',
  passwordMaxLength: 'Password must be less than 32 characters',
  passwordRequirements:
    'Password must contain at least 8 Latin characters, one uppercase letter, and one digit',
  passwordsMatch: 'Passwords must match',

  // errors back-end
  'Email in use': 'Email in use.',
};
